import * as actionType from "./constants";
import { getSessionDefaultClientId, getSessionDefaultProjectId } from "../../utils/dashboardSession";

const initialState = {
    rotateImageResponse: {},
    exportImageResponse: {},
    imageUploadResponse: {},
    imageLogsResponse: {},
    imageUpdateResponse: {},
    projectList: {},
    buildingList: {},
    tradeList: {},
    systemList: {},
    subsystemList: {},
    recommendationsList: {},
    duplicateImages: {},
    imagesResponse: {
        isLoading: false
    },
    imageUpdateGlobalResponse: {
        isLoading: false
    },
    masterFilterList: {
        clients: [],
        projects: [],
        reagions: [],
        sites: [],
        buildings: [],
        trade: [],
        system: [],
        subSystem: [],
        labels: []
    },
    selectedProject: {},
    selectedImages: [],
    checkImageMapped: {},
    deleteImageResponse: {},
    getUserDefaultTradeResponse: {},
    uploadProgress: 0,
    defaultProject: "",
    defaultClient: "",
    addToFav: {},
    entityParams: {
        master: {
            isGridView: true,
            imageParams: {
                limit: 100,
                offset: 1,
                search: "",
                filters: {},
                order: { "image_upload.created_date": "desc" }
            },
            sortOrder: "desc",
            masterFilters: {
                client_ids: [],
                project_ids: [],
                region_ids: [],
                site_ids: [],
                building_ids: [],
                trade_ids: [],
                system_ids: [],
                sub_system_ids: [],
                user_ids: [],
                image_tag_ids: [],
                client_standard: [],
                uniformat_level_6_ids:[],
                uniformat_level_5_ids:[]
            },
            isFilterReset: false,
            showSelected: false,
            selectedImages: []
        },
        // The Image Analyse page (AI Settings) - the same grid as `master`, but its OWN slot, so filters and a
        // selection made in Image Management do not carry over into "Analyse Selected" there, and back.
        imageAnalysis: {
            isGridView: true,
            imageParams: {
                limit: 100,
                offset: 1,
                search: "",
                filters: {},
                order: { "image_upload.created_date": "desc" }
            },
            sortOrder: "desc",
            masterFilters: {
                client_ids: [],
                project_ids: [],
                region_ids: [],
                site_ids: [],
                building_ids: [],
                trade_ids: [],
                system_ids: [],
                sub_system_ids: [],
                user_ids: [],
                image_tag_ids: [],
                client_standard: [],
                uniformat_level_6_ids:[],
                uniformat_level_5_ids:[],
                client_standard_ids:[]
            },
            isFilterReset: false,
            showSelected: false,
            selectedImages: []
        },
        assign: {
            isGridView: true,
            imageParams: {
                limit: 100,
                offset: 1,
                search: "",
                filters: {},
                order: { [actionType.ASSIGN_VIEW_DEFAULT_SORT_KEY]: actionType.ASSIGN_VIEW_DEFAULT_SORT_ORDER }
            },
            sortOrder: actionType.ASSIGN_VIEW_DEFAULT_SORT_ORDER,
            masterFilters: {
                client_ids: [],
                project_ids: [],
                region_ids: [],
                site_ids: [],
                building_ids: [],
                trade_ids: [],
                system_ids: [],
                sub_system_ids: [],
                user_ids: [],
                image_tag_ids: [],
                client_standard: []
            },
            isFilterReset: false,
            showSelected: false,
            selectedImages: []
        }
    },
    scrollPosition: 0,
    getLabelList: [],
    saveEditedImageResponse: {},
    getImageAnalysisData: {},
    patchImageAnalysisData: {},
    assignImageResponse: {},
    getAnalyseResponse: { loading: false, total: 0, results: [] },
    getTotalAnalyseData: {},
    getRawImageAnalysisData: { isLoading: false },
    savedRawImageAnalysisData: {},
    imageBulkDownloadResponse: {},
    getImageDownloadProjectsListResponse: {}
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPLOAD_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.UPLOAD_IMAGE_SUCCESS:
            return {
                ...state,
                imageUploadResponse: { success: true, ...action.response }
            };
        case actionType.UPLOAD_IMAGE_FAILURE:
            return {
                ...state,
                imageUploadResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_IMAGE_SUCCESS:
            return {
                ...state,
                imageUpdateResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_IMAGE_FAILURE:
            return {
                ...state,
                imageUpdateResponse: { success: false, ...action.error }
            };
        case actionType.GET_PROJECT_LIST_REQUEST:
            return {
                ...state,
                projectList: { loading: true }
            };
        case actionType.GET_PROJECT_LIST_SUCCESS:
            return {
                ...state,
                projectList: { success: true, ...action.response, loading: false }
            };
        case actionType.GET_PROJECT_LIST_FAILURE:
            return {
                ...state,
                projectList: { success: false, ...action.error, loading: false }
            };
        case actionType.GET_BUILDING_LIST_REQUEST:
            return {
                ...state,
                buildingList: { loading: true }
            };
        case actionType.GET_BUILDING_LIST_SUCCESS:
            return {
                ...state,
                buildingList: { success: true, ...action.response, loading: false }
            };
        case actionType.GET_BUILDING_LIST_FAILURE:
            return {
                ...state,
                buildingList: { success: false, ...action.error, loading: false }
            };

        case actionType.GET_SELECTED_PROJECT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_SELECTED_PROJECT_SUCCESS:
            return {
                ...state,
                selectedProject: { success: true, ...action.response }
            };
        case actionType.GET_SELECTED_PROJECT_FAILURE:
            return {
                ...state,
                selectedProject: { success: false, ...action.error }
            };

        case actionType.GET_TRADE_LIST_REQUEST:
            return {
                ...state,
                tradeList: { loading: true }
            };
        case actionType.GET_TRADE_LIST_SUCCESS:
            return {
                ...state,
                tradeList: { success: true, ...action.response, loading: false }
            };
        case actionType.GET_TRADE_LIST_FAILURE:
            return {
                ...state,
                tradeList: { success: false, ...action.error, loading: false }
            };
        case actionType.GET_SYSTEM_LIST_REQUEST:
            return {
                ...state,
                systemList: { loading: true }
            };
        case actionType.GET_SYSTEM_LIST_SUCCESS:
            return {
                ...state,
                systemList: { success: true, ...action.response, loading: false }
            };
        case actionType.GET_SYSTEM_LIST_FAILURE:
            return {
                ...state,
                systemList: { success: false, ...action.error, loading: false }
            };
        case actionType.GET_SUBSYSTEM_LIST_REQUEST:
            return {
                ...state,
                subsystemList: { loading: true }
            };
        case actionType.GET_SUBSYSTEM_LIST_SUCCESS:
            return {
                ...state,
                subsystemList: { success: true, ...action.response, loading: false }
            };
        case actionType.GET_SUBSYSTEM_LIST_FAILURE:
            return {
                ...state,
                subsystemList: { success: false, ...action.error, loading: false }
            };
        case actionType.CHECK_DUPLICATE_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.CHECK_DUPLICATE_IMAGE_SUCCESS:
            return {
                ...state,
                duplicateImages: { success: true, ...action.response }
            };
        case actionType.CHECK_DUPLICATE_IMAGE_FAILURE:
            return {
                ...state,
                duplicateImages: { success: false, ...action.error }
            };
        case actionType.GET_ALL_IMAGES1_REQUEST:
            return {
                ...state,
                imagesResponse: { isLoading: true }
            };
        case actionType.GET_ALL_IMAGES1_SUCCESS:
            return {
                ...state,
                imagesResponse: { success: true, isLoading: true, ...action.response }
            };
        case actionType.GET_ALL_IMAGES1_FAILURE:
            return {
                ...state,
                imagesResponse: { success: false, isLoading: false, ...action.error }
            };
        case actionType.GET_FILTER_LISTS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_FILTER_LISTS_SUCCESS:
            console.log(action.response);
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.filterKey]: [...(action.response[action.filterKey] ?? action?.response?.list ?? [])]
                },
                defaultProject: getSessionDefaultProjectId() || state.defaultProject,
                defaultClient: getSessionDefaultClientId() || state.defaultClient
            };
        case actionType.GET_FILTER_LISTS_FAILURE:
            return {
                ...state,
                masterFilterList: { success: false, ...action.error }
            };
        case actionType.GET_IMAGE_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.GET_IMAGE_LOG_SUCCESS:
            return {
                ...state,
                imageLogsResponse: { success: true, ...action.response }
            };
        case actionType.GET_IMAGE_LOG_FAILURE:
            return {
                ...state,
                imageLogsResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_SELECTED_IMAGES:
            return {
                ...state,
                selectedImages: action.response
            };
        case actionType.CHECK_IMAGE_MAPPED_REQUEST:
            return {
                ...state
            };
        case actionType.CHECK_IMAGE_MAPPED_SUCCESS:
            return {
                ...state,
                checkImageMapped: { success: true, ...action.response }
            };
        case actionType.CHECK_IMAGE_MAPPED_FAILURE:
            return {
                ...state,
                checkImageMapped: { success: false, ...action.error }
            };
        case actionType.DELETE_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_IMAGE_SUCCESS:
            return {
                ...state,
                deleteImageResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_IMAGE_FAILURE:
            return {
                ...state,
                deleteImageResponse: { success: false, ...action.error }
            };
        case actionType.ADD_UPLOAD_PROGRESS:
            return {
                ...state,
                uploadProgress: action.response
            };
        case actionType.SET_UPLOAD_PROGRESS:
            return {
                ...state,
                uploadProgress: action.response
            };
        case actionType.ADD_TO_FAV_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_TO_FAV_SUCCESS:
            return {
                ...state,
                addToFav: { success: true, ...action.response }
            };
        case actionType.ADD_TO_FAV_FAILURE:
            return {
                ...state,
                addToFav: { success: false, ...action.error }
            };
        case actionType.UPDATE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...state.entityParams, [action.response.type]: { ...action.response } }
            };
        case actionType.UPDATE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.UPDATE_IMG_SCROLL_POSITION_SUCCESS:
            return {
                ...state,
                scrollPosition: action.response
            };
        case actionType.UPDATE_IMG_SCROLL_POSITION_FAILURE:
            return {
                ...state,
                scrollPosition: 0
            };
        case actionType.GET_USER_DEFAULT_TRADE_REQUEST:
            return {
                ...state
            };
        case actionType.GET_USER_DEFAULT_TRADE_SUCCESS:
            return {
                ...state,
                getUserDefaultTradeResponse: { success: true, ...action.response }
            };
        case actionType.GET_USER_DEFAULT_TRADE_FAILURE:
            return {
                ...state,
                getUserDefaultTradeResponse: { success: false, ...action.error }
            };
        case actionType.GET_LABEL_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LABEL_LIST_SUCCESS:
            return {
                ...state,
                getLabelList: { success: true, ...action.response }
            };
        case actionType.GET_LABEL_LIST_FAILURE:
            return {
                ...state,
                getLabelList: { success: false, ...action.error }
            };
        case actionType.EXPORT_IMAGES_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.EXPORT_IMAGES_LIST_SUCCESS:
            return {
                ...state,
                exportImageResponse: { success: true, ...action.response }
            };
        case actionType.EXPORT_IMAGES_LIST_FAILURE:
            return {
                ...state,
                exportImageResponse: { success: false, ...action.error }
            };
        //rotate images
        case actionType.ROTATE_IMAGES_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.ROTATE_IMAGES_LIST_SUCCESS:
            return {
                ...state,
                rotateImageResponse: { success: true, ...action.response }
            };
        case actionType.ROTATE_IMAGES_LIST_FAILURE:
            return {
                ...state,
                rotateImageResponse: { success: false, ...action.error }
            };
        case actionType.SAVE_EDITED_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_EDITED_IMAGE_SUCCESS:
            return {
                ...state,
                saveEditedImageResponse: { success: true, ...action.response }
            };
        case actionType.SAVE_EDITED_IMAGE_FAILURE:
            return {
                ...state,
                saveEditedImageResponse: { success: false, ...action.error }
            };
        case actionType.RESTORE_EDITED_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.RESTORE_EDITED_IMAGE_SUCCESS:
            return {
                ...state,
                saveEditedImageResponse: { success: true }
            };
        case actionType.RESTORE_EDITED_IMAGE_FAILURE:
            return {
                ...state,
                saveEditedImageResponse: { success: false, ...action.error }
            };
        case actionType.RESET_IMAGE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: {
                    ...state.entityParams,
                    master: {
                        ...state.entityParams.master,
                        isGridView: true,
                        imageParams: {
                            limit: 100,
                            offset: 1,
                            search: "",
                            filters: {},
                            order: { "image_upload.created_date": "desc" }
                        },
                        sortOrder: "desc",
                        masterFilters: {
                            client_ids: [],
                            project_ids: [],
                            region_ids: [],
                            site_ids: [],
                            building_ids: [],
                            trade_ids: [],
                            system_ids: [],
                            sub_system_ids: [],
                            user_ids: [],
                            image_tag_ids: [],
                            client_standard: []
                        },
                        isFilterReset: false,
                        showSelected: false,
                        selectedImages: []
                    }
                }
            };
        case actionType.GET_IMAGE_ANALYSIS_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_IMAGE_ANALYSIS_DATA_SUCCESS:
            return {
                ...state,
                getImageAnalysisData: { success: true, ...action.response }
            };
        case actionType.GET_IMAGE_ANALYSIS_DATA_FAILURE:
            return {
                ...state,
                getImageAnalysisData: { success: false, ...action.error }
            };
        case actionType.PATCH_IMAGE_ANALYSIS_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.PATCH_IMAGE_ANALYSIS_DATA_SUCCESS:
            return {
                ...state,
                patchImageAnalysisData: { success: true, ...action.response }
            };
        case actionType.PATCH_IMAGE_ANALYSIS_DATA_FAILURE:
            return {
                ...state,
                patchImageAnalysisData: { success: false, ...action.error }
            };
        case actionType.CLEAR_PATCH_IMAGE_ANALYSIS_DATA_REQUEST:
            return {
                ...state,
                patchImageAnalysisData: {},
                getAnalyseResponse: action?.response ? { isLoading: false, total: 0, results: [] } : state.getAnalyseResponse
            };
        case actionType.ASSIGN_IMAGES_TO_SECTION_REQUEST:
            return {
                ...state
            };
        case actionType.ASSIGN_IMAGES_TO_SECTION_SUCCESS:
            return {
                ...state,
                assignImageResponse: { success: true, ...action.response }
            };
        case actionType.ASSIGN_IMAGES_TO_SECTION_FAILURE:
            return {
                ...state,
                assignImageResponse: { success: false, ...action.error }
            };

        case actionType.UPDATE_IMAGE_GLOBAL_REQUEST:
            return {
                ...state,
                imageUpdateGlobalResponse: { isLoading: true }
            };
        case actionType.UPDATE_IMAGE_GLOBAL_SUCCESS:
            return {
                ...state,
                imageUpdateGlobalResponse: { success: true, isLoading: false, ...action.response }
            };
        case actionType.UPDATE_IMAGE_GLOBAL_FAILURE:
            return {
                ...state,
                imageUpdateGlobalResponse: { success: false, isLoading: false, ...action.error }
            };
        case actionType.GET_AWS_REKOGNITION_REQUEST:
            return {
                ...state,
                ...(action?.isTotalFetch
                    ? { getTotalAnalyseData: { loading: true } }
                    : { getAnalyseResponse: { loading: true, ...state?.getAnalyseResponse } })
            };
        case actionType.GET_AWS_REKOGNITION_SUCCESS:
            return {
                ...state,
                ...(action?.isTotalFetch
                    ? { getTotalAnalyseData: action.response }
                    : {
                          getAnalyseResponse: {
                              ...action.response,
                              success: true,
                              results: [...(state.getAnalyseResponse?.results || []), ...(action.response?.results || [])],
                              loading: false
                          }
                      })
            };
        case actionType.GET_AWS_REKOGNITION_FAILURE:
            return {
                ...state,
                ...(action?.isTotalFetch
                    ? { getTotalAnalyseData: action.error }
                    : { getAnalyseResponse: { success: false, ...action.error, loading: false } })
            };
        case actionType.GET_RAW_IMAGE_ANALYSIS_DATA_REQUEST:
            return {
                ...state,
                getRawImageAnalysisData: { isLoading: true }
            };
        case actionType.GET_RAW_IMAGE_ANALYSIS_DATA_SUCCESS:
            return {
                ...state,
                getRawImageAnalysisData: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_RAW_IMAGE_ANALYSIS_DATA_FAILURE:
            return {
                ...state,
                getRawImageAnalysisData: { isLoading: false, success: false, ...action.error }
            };
        case actionType.ADD_RAW_IMAGE_ANALYSIS_DATA_REQUEST:
            return {
                ...state,
                savedRawImageAnalysisData: { isLoading: true }
            };
        case actionType.ADD_RAW_IMAGE_ANALYSIS_DATA_SUCCESS:
            return {
                ...state,
                savedRawImageAnalysisData: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_RAW_IMAGE_ANALYSIS_DATA_FAILURE:
            return {
                ...state,
                savedRawImageAnalysisData: { isLoading: false, success: false, ...action.error }
            };
        case actionType.IMAGE_BULK_DOWNLOAD_REQUEST:
            return {
                ...state,
                imageBulkDownloadResponse: { isLoading: true }
            };
        case actionType.IMAGE_BULK_DOWNLOAD_SUCCESS:
            return {
                ...state,
                imageBulkDownloadResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.IMAGE_BULK_DOWNLOAD_FAILURE:
            return {
                ...state,
                imageBulkDownloadResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.GET_IMAGE_DOWNLOAD_PROJECTS_LIST_REQUEST:
            return {
                ...state,
                getImageDownloadProjectsListResponse: { isLoading: true }
            };
        case actionType.GET_IMAGE_DOWNLOAD_PROJECTS_LIST_SUCCESS:
            return {
                ...state,
                getImageDownloadProjectsListResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_IMAGE_DOWNLOAD_PROJECTS_LIST_FAILURE:
            return {
                ...state,
                getImageDownloadProjectsListResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.CLEAR_IMAGE_DOWNLOAD_PROJECTS_LIST:
            return {
                ...state,
                getImageDownloadProjectsListResponse: {}
            };
        default:
            return state;
    }
};

export default reducers;
